export default "__VITE_ASSET__IlBcMInx__"